export default __webpack_public_path__ + "static/media/O-158.72799e1b.png";